module.exports = __webpack_public_path__ + "img/bg.0178da64.png";